import env from '@tcc/env-detect';
import queryString from 'query-string';
import { queryParam } from '../../utils/queryString';
import { LinkDescriptor, NavigationItem, NavigationItemType, NavigationLink, NavigationMenu, UrlPlaceholders } from './types';

const parseLink = (href, queryParams) => {
  if (!href.includes(UrlPlaceholders.ROOT_URL) && !href.includes(UrlPlaceholders.QUERY_PARAMS)) {
    return href;
  }

  const subDomain = env.isEnv('production') ? '' : `${env.getCurrentEnv()}.`;
  const prefix = `https://${subDomain}climate.com`;

  const queryParamsString = queryString.stringify({
    ...queryParams,
    'client-id': queryParam('client-id'),
  });
  const suffix = queryParamsString ? `?${queryParamsString}` : '';

  return href
    .replace(UrlPlaceholders.ROOT_URL, prefix)
    .replace(UrlPlaceholders.QUERY_PARAMS, suffix);
};

export const descriptorToNavigationLink = (
  descriptor: LinkDescriptor,
  location: Location
): NavigationLink => {
  const { label, href, testId, queryParams, isActiveRegexs, id, ...rest } = descriptor;

  const isActive = isActiveRegexs?.some(rgx => RegExp(rgx).test(location.pathname));

  return {
    id,
    label,
    testId,
    href: parseLink(href, queryParams),
    isActive,
    ...rest
  };
};

export const toExperimentalSpaLinks = (navLink: NavigationLink): NavigationLink => {
  const currentPath = window.location.pathname;
  const isInExperimentalFieldView = currentPath.includes('static/global/exp/field-view/');
  const isFieldViewLink = navLink.href.includes('static/field-view/#');

  if (isInExperimentalFieldView && isFieldViewLink) {
    const [experimentSpaUrl] = currentPath.split('#');
    const [, pluginHashRoute] = navLink.href.split('#');

    return {
      ...navLink,
      href: `${experimentSpaUrl}#${pluginHashRoute}`
    };
  }

  return navLink;
};

export const toNavigationItem = (item: NavigationLink | NavigationMenu): NavigationItem => ({
  id: item?.id,
  order: item?.order,
  type: Object.prototype.hasOwnProperty.call(item, 'links') ? NavigationItemType.MENU : NavigationItemType.LINK,
  data: item,
});

export const byOrderOrDefault = (a: NavigationItem, b: NavigationItem): number => {
  if (!a.order && !b.order) return 0;
  if (!a.order) return 1;
  if (!b.order) return -1;
  return a.order - b.order;
};
